import axios, { AxiosResponse } from "axios";
import { API_ROUTE } from "../const/apiRoute";
import { apiGHTK, apiPos, apiSCA } from "../library/axios";
import { repositoryDelivery, repositoryPos } from "../_base/_const/_constVar";
import { MessageResponse } from "../model/MessageResponse";

export const takeDeliveryfeeSCA = async (data: any): Promise<any> => {
  const token =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhZGRyZXNzIjoiMTMxIGzDqiB0aGFuaCBuZ2jhu4siLCJ3YXJkc19pZCI6OTUsInBvc3RJZCI6MCwidG9rZW4iOm51bGwsInVzZXJfaWQiOjI4NjU5LCJwaG9uZSI6Ijg0OTQyMDQ0MDc4IiwicHJvdmluY2VfaWQiOjEsIm5hbWUiOiJIYWNvbSIsInBvc3RDb2RlIjpudWxsLCJkaXN0cmljdF9pZCI6NywiZXhwIjoxNzY1MjY0NjgxLCJpYXQiOjE3MzM3Mjg2ODEyNzEsInVzZXJuYW1lIjoiODQ5NDIwNDQwNzgifQ.XURT7wFNa9xNnjQ7v67J_59ClD96Jqha2RjZpamCid4ygiV59_v5vMcT0DQA_w7c3eUmPRnf3U3uMFjd0WlSmRc5qBRmHqqT72_Hg2Pnn3xa5dVooDPwmeYxoH8FxihgRxAgeurqihWANYUd-aOQqN8kHtSef6QIRvtHO8lGPxA";
  try {
    const response: AxiosResponse = await apiSCA.post(
      `${API_ROUTE.GET_PRICE_ALL}`,
      data,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
};

export async function takeDeliveryfeeGHTK() {
  const url = "/api/v1/GhtkIntegration/fee";
  const callapi = await repositoryDelivery.get<MessageResponse<any[]>>(url);
  if (callapi?.success) return callapi?.data;
  return [];
}

// export const takeDeliveryfeeGHTK = async (query: string): Promise<any> => {
//   const token = "28968247a8f3462d882ca5bca7d81971fa842cbc";
//   try {
//     const response: AxiosResponse = await apiGHTK.get(
//       `${API_ROUTE.GET_DATA_DELIVERY_FEE_GHTK}` + query,
//       {
//         headers: {
//           Token: token,
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     // HandleResponseError(error);
//     return [];
//   }
// };

export const takeProviceId = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await apiSCA.get(
      `${API_ROUTE.GET_LIST_PROVINCE_SCA}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
};

export const takeDistrictId = async (idProvince: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiSCA.get(
      `${API_ROUTE.GET_LIST_DISTRICT_SCA}?province_id=${idProvince}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
};

export const takeDeliveryfeeViettel = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiPos.post(
      `${API_ROUTE.GET_DATA_DELIVERY_FEE_VIETTEL}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    // HandleResponseError(error);
    return [];
  }
};

export const createAhamoveOrder = async (data: any) => {
  try {
    const response = await axios.post(
      "https://partner-apistg.ahamove.com/v3/orders",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ1c2VyIiwiY2lkIjoiODQ5NjQ2MzUxMzYiLCJzdGF0dXMiOiJPTkxJTkUiLCJlb2MiOiJ2YW52aW5oc3B1ckBnbWFpbC5jb20iLCJub2MiOiJDw7RuZyB0eSBD4buVIHBo4bqnbiDEkOG6p3UgdMawIEPDtG5nIG5naOG7hyBIQUNPTSBBZG1pbiIsImN0eSI6IlNHTiIsInR5cGUiOiJhcGkiLCJwYXJ0bmVyIjoiaGFjb20iLCJleHAiOjE4MTY5NDM5MDUsImlhdCI6MTc1Mzg3MTkwNSwiaXNzIjoiYWhhIn0.fO6fONjUfp2KzIlgYX5HjeNa06UfFxa1BEVHANnrj7U", // 🔁 Thay <token> bằng token thật từ Postman
        },
      }
    );

    console.log("Ahamove response:", response.data);
    return response;
  } catch (error: any) {
    console.error("Ahamove API error:", error.response?.data || error.message);
    return error.response?.data || error.message;
  }
};

export const getAhamoveEstimates = async (data: any): Promise<any> => {
  try {
    const response = await axios.post(
      "https://partner-api.ahamove.com/v3/orders/estimates",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ1c2VyIiwiY2lkIjoiODQ5ODg2NTUxMzAiLCJzdGF0dXMiOiJPTkxJTkUiLCJub2MiOiJoYWNvbSIsImN0eSI6IkhBTiIsInR5cGUiOiJhcGkiLCJwYXJ0bmVyIjoiaGFjb20iLCJleHAiOjE4MTAxMDMxMTEsImlhdCI6MTc0NzAzMTExMSwiaXNzIjoiYWhhIn0.fe4rRIj4RCE9-3j8skI9Iptx_4JorGvkEr8cdRngt6A",
        },
      }
    );

    console.log("Ahamove estimates response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error(
      "Ahamove estimates API error:",
      error.response?.data || error.message
    );
    return {
      success: false,
      error: error.response?.data || error.message,
    };
  }
};

export const getGrabExpressQuotes = async (data: any): Promise<any> => {
  try {
    const url = "/api/v1/GrabExpressProxy/quotes";
    const response = await repositoryDelivery.post<any>(url, data);
    return response;
  } catch (error: any) {
    console.error("GrabExpress quotes API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export interface PushAhamoveOrderResult {
  success: boolean;
  message: string;
  orderNumber: string;
  ahamoveOrderId: string | null;
  sharedLink: string | null;
  serviceId: string | null;
  pickupAddress: string | null;
  deliveryAddress: string | null;
  httpStatus: number | null;
}

export interface PushAhamoveOrderRequest {
  orderNumber?: string; // mã đơn hàng, bỏ trống khi truyền deliveryId
  deliveryId?: number; // phiếu giao vận khi đẩy từ màn Đơn giao hàng (đơn hàng hoặc điều chuyển)
  // tạo lại dù đơn đã có đơn Ahamove / lần trước chưa rõ kết quả
  force: boolean;
  // ECO / BIKE (BE tự thêm HAN / SGN) hoặc nguyên service_id như HAN-ECO.
  // Bỏ trống: BE theo loại giao trên đơn, đơn điều chuyển đi BIKE
  serviceType?: string;
  note?: string; // ghi chú phiếu giao vận, bỏ trống: "Đẩy đơn sang Ahamove"
  attribute60?: string; // cờ đóng gói, bỏ trống thì giữ giá trị đang có
}

// Đẩy đơn sang Ahamove qua BE: BE tự dựng địa chỉ, gọi Ahamove và lưu sharedLink vào đơn
// (truyền deliveryId thì BE cập nhật luôn phiếu giao vận).
// Trả undefined khi lỗi HTTP (repositoryDelivery đã hiện thông báo).
export const pushAhamoveOrder = async (body: PushAhamoveOrderRequest) =>
  repositoryDelivery.post<MessageResponse<PushAhamoveOrderResult>>(
    "/api/v1/Ahamove/push-order",
    body
  );

// BE trả các câu này khi cần người dùng xác nhận tạo lại đơn (gọi lại với force = true)
export const isAhamoveNeedForce = (message?: string) =>
  ["Đơn đã có đơn Ahamove", "Lần đẩy trước chưa rõ kết quả"].some((p) =>
    message?.startsWith(p)
  );

export const createGrabExpressDelivery = async (data: any): Promise<any> => {
  try {
    const url = "/api/v1/GrabExpressProxy/deliveries";
    const response = await repositoryDelivery.post<any>(url, data);
    return response;
  } catch (error: any) {
    console.error("GrabExpress create delivery API error:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};
